import React from "react";
import { Link } from "react-router-dom";

const LOGO_SRC =
  "https://customer-assets-jt897jd0.emergentagent.net/job_tender-goldberg-9/artifacts/1kwkf9ch_Generated%20image%201%20%285%29.png";

/**
 * Canonical Medical Peptide Store brand-mark link.
 *
 * `widthClass` — override the responsive width (Tailwind classes). Feb 2026
 * redesign asks for a much larger, brand-dominant treatment: header gets
 * ~155–185 px mobile / ~200–240 px desktop; footer gets an equally
 * prominent presence. Callers may still pass a raw `height` (legacy).
 */
export const Logo = ({
  className = "",
  height = 56,
  widthClass = null,
}) => (
  <Link
    to="/"
    data-testid="site-logo"
    className={`flex items-center group ${className}`}
    aria-label="Medical Peptide Store — home"
  >
    <img
      src={LOGO_SRC}
      alt="Medical Peptide Store"
      className={`block object-contain group-hover:opacity-90 transition-opacity ${
        widthClass ? `h-auto ${widthClass}` : ""
      }`}
      style={widthClass ? undefined : { height, width: "auto" }}
      loading="eager"
      decoding="async"
    />
  </Link>
);
